export enum Technology {
	DWDM = '100000000',
	Ethernet = '100000002',
	FTTH = '226530000',
	TDM = '100000001',
}
